export enum FairplayerFallbackImageUi {
  BANNER = 'BANNER',
  EXCLUSIVE = 'EXCLUSIVE',
  FAN = 'FAN',
  LOGO = 'LOGO',
}
